import { FilmoscopeAdapter } from '@kinopoisk-int/ott-player-tracker';
import { PlayerTrackerWithPluggableSender } from '@kinopoisk-int/ott-player-tracker/dist/lib/PlayerTrackerWithPluggableSender';
import { Sender } from '@kinopoisk-int/ott-player-tracker/dist/types/sender';
import { ExtraData } from '@kinopoisk-int/ott-player-tracker/dist/lib/HTMLRequestSender/types';
import { MacroValueGetters } from '@kinopoisk-int/ott-player-tracker/dist/lib/PlayerTracker/types';
import { FilmoscopeApi } from '@kinopoisk-int/filmoscope';

import { PlayerAdapter } from '@/scenarios/legacy-player/types/instance';

export function createNewPlayerTracker(
    instance: PlayerAdapter,
    sender: Sender<ExtraData, MacroValueGetters>
) {
    const player = new FilmoscopeAdapter(instance.pureInstance as FilmoscopeApi);

    return new PlayerTrackerWithPluggableSender({
        sender,
        player,
        adController: null,
    });
}
